
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cars/new/[[...slug]]",
      function () {
        return require("private-next-pages/cars/new/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cars/new/[[...slug]]"])
      });
    }
  